export default 'https://help.local.kazaar.com';
